import { render, staticRenderFns } from "./PrescriptionList.vue?vue&type=template&id=03b68b9c"
import script from "./PrescriptionList.vue?vue&type=script&lang=js"
export * from "./PrescriptionList.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionList.vue?vue&type=style&index=0&id=03b68b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports